import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from 'next-seo.config';

import { NewsletterSignup } from '@/components/NewsletterSignup';

import { routes } from '@/utils/routes';

const NEWSLETTER_SIGNUP_TITLE = 'Matcha Newsletter';
const NEWSLETTER_SIGNUP_DESCRIPTION =
  'Subscribe to the Matcha Newsletter for the latest DeFi news, crypto trading tips and Web3 insights delivered directly to your email inbox.';

const NewsletterSignupPage: NextPage = () => (
  <>
    <NextSeo
      {...DEFAULT_SEO_CONFIG}
      title={NEWSLETTER_SIGNUP_TITLE}
      description={NEWSLETTER_SIGNUP_DESCRIPTION}
      canonical={`${ROOT_URL_PRODUCTION}${routes.NEWSLETTER_SIGNUP}`}
      additionalMetaTags={[
        {
          name: 'twitter:title',
          content: NEWSLETTER_SIGNUP_TITLE,
        },
        {
          name: 'twitter:description',
          content: NEWSLETTER_SIGNUP_DESCRIPTION,
        },
        {
          name: 'twitter:url',
          content: `${ROOT_URL_PRODUCTION}${routes.NEWSLETTER_SIGNUP}`,
        },
      ]}
    />
    <NewsletterSignup />
  </>
);

export default NewsletterSignupPage;
